import React from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'

function ImgSlider()  {
  return (
        <>
          <div className="welcometext">
      
            <span className="static">Welcome to</span>
            <span className="dynamictext">www.UnlockCode.tech</span>
      
          </div>

          
        </>
    )
}

export default ImgSlider;